import { useState } from "react";
import CampaignListTable from "./campaign-list-table";
import { CampaignListParam, fetchCampaignList } from "src/app/modules/PruleadInsightsReporting/network/campaignCrud";
import { PaginateList } from "src/app/common/types";
import { CampaignItem, CampaignStatusEnum } from "src/app/modules/PruleadInsightsReporting/types/insights-types";
import { useDataProvider } from "src/app/common/utils";
import { useDispatch } from "react-redux";
import CampaignListFilter from "./campaign-list-filter";

const initialState: CampaignListParam = {
  name: '',
  startDateFrom: null,
  startDateTo: null,
  endDateFrom: null,
  endDateTo: null,
  sourceId: '',
  sort: '',
  status: CampaignStatusEnum.ACTIVE,
  limit: 5,
  page: 1,
};


interface CampaignListProps {
  selectedRow: CampaignItem | null;
  onRowSelected: (campaign: CampaignItem | null) => void;
}
const CampaignList = (props: CampaignListProps) => {
  const { selectedRow, onRowSelected } = props;

  const dispatch = useDispatch();

  const [filterState, setFilterState] = useState<CampaignListParam>(initialState);
  const [campaignList, setCampaignList] = useState<PaginateList<CampaignItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateList<CampaignItem>>(
    async () => {
      try {
        return await fetchCampaignList(filterState, dispatch);
      } catch (err) { }
    },
    setCampaignList,
    false,
  );

  return (
    <>
      <CampaignListFilter
        filterState={filterState}
        onChangeFilter={setFilterState}
        onSearch={refreshData}
      />
      <CampaignListTable
        singleSelect={true}
        isLoading={isLoading}
        onRefresh={refreshData}
        campaignList={campaignList}
        page={filterState.page}
        limit={filterState.limit}
        selectedRows={selectedRow ? [selectedRow] : []}
        onRowsSelected={(rows) => onRowSelected(rows[0] || null)}
        onChangePage={(page: number, limit: number) => {
          setFilterState((previous) => ({
            ...previous,
            page,
            limit
          }));
          refreshData();
        }}
      />
    </>
  );
};

export default CampaignList;